import { FC } from "react";
import HomeCard from "../home/HomeCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons";

// eGroups Home Component
/**
 * This component is used to display the eGroups Map and Campus select options for users
 * to search for and sign up for eGroups.
 *
 * The campus values are being pulled from this.props.actions.Main_get_all_campuses().
 * Check this action and the api calls set up within them if you run into any problems.
 */

export const CampusOnlineSelector: FC<{
    onlineLink?: string;
    campusLink?: string;
    onlineLinkID: string;
    campusLinkID: string;
    campusLinkExternal: boolean;
    onlineLinkExternal: boolean;
    title?: string;
    subtitle?: string;

    campusOnCardClick?: Function;

    onlineOnCardClick?: Function;
}> = ({
    onlineLink,
    campusLink,
    campusLinkExternal,
    onlineLinkExternal,
    campusLinkID,
    onlineLinkID,
    onlineOnCardClick,
    campusOnCardClick,
    title = "Choose your community",
    subtitle = "Whether you are visiting a local campus community or joining us online for the very first time, we can’t wait to connect with you!",
}) => (
    <div className="campus-selection p-y-spacer-3xl">
        <div className="container">
            <h1 className="m-y-spacer-none text-center font-size-34">
                {title}
            </h1>
            <p className="m-y-spacer-none m-t-spacer-md half-here text-center font-size-16">
                {subtitle}
            </p>
        </div>
        <div className="campus-options-wrapper flex flex-row flex-wrap cards-wrapper">
            <div className="p-spacer-md card-wrapper">
                <HomeCard
                    cardlink={campusLink || "#"}
                    externalLink={campusLinkExternal}
                    imgdiv="card-image"
                    imgURL="https://cdn.elevationchurch.org/images/connection_center/campus_selector/campus_new"
                    icon={
                        // <i className="fal fa-map-marker-alt font-size-28 ec-text-white" />
                        <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            className="font-size-32 ec-text-white"
                            aria-hidden="true"
                        />
                    }
                    iconcolor="icon-generic"
                    title="Campus Community"
                    className="smaller-card campus-community-card"
                    description="I'm a part of a local campus community."
                    showMobile={true}
                    id={campusLinkID}
                    onCardClick={campusOnCardClick}
                />
            </div>

            <div className="p-spacer-md card-wrapper">
                <HomeCard
                    cardlink={onlineLink || "#"}
                    externalLink={onlineLinkExternal}
                    imgdiv="eFam-img-div card-image"
                    imgURL="https://cdn.elevationchurch.org/images/connection_center/campus_selector/eFam"
                    objectPosition="top"
                    icon={
                        <i className="ecicon-online font-size-26 ec-text-white" />
                    }
                    iconcolor="icon-generic"
                    title="eFam"
                    className="smaller-card campus-community-card"
                    description="I'm a part of the online community."
                    showMobile={true}
                    id={onlineLinkID}
                    onCardClick={onlineOnCardClick}
                />
            </div>
        </div>
    </div>
);
